<template>
    <div class="tools-rank-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>批次位次查询</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="zy-school" type="flex" justify="space-between" :gutter="16">
            <el-col :span="16">
                <el-tabs type="border-card" class="rank-box zy-list" @tab-click="handleChangeCard">
                    <el-tab-pane :label="card" v-for="(card,card_index) in cardList" :key="card_index" v-model="activeCardIndex">
                    </el-tab-pane>
                </el-tabs>
                <el-row class="tools-batch-box" v-if="activeCardIndex == 0">
                    <el-row class="tools-box-content">
                        <el-row class="tools-batch-list">
                            <h5><span>({{province}})</span>近五年批次线统计</h5>
                            <el-table :data="scoreLineList" stripe style="width: 100%" border class="tools-table-box">
                                <el-table-column label="年份" width="130">
                                    <template slot-scope="scope">
                                        <img src="../../assets/images/tools-year.png">
                                        {{ scope.row.year }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="科目" width="132">
                                    <template slot-scope="scope">
                                        <!-- {{ local_type_list[scope.row.local_type_id] }} -->
                                        {{ scope.row.year > 2024 ? scope.row.local_type_id == '1' || scope.row.local_type_id == '3' ? '物理': '历史' : scope.row.local_type_id == '1' || scope.row.local_type_id == '3' ? '理科': '文科' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="year" label="批次" width="172">
                                    <template slot-scope="scope">
                                       <div v-if="scope.row.year == '2025'||scope.row.year == '2026'">{{ local_batch_new_list[scope.row.local_batch_id] }}</div>
                                       <div v-else>{{ local_batch_list[scope.row.local_batch_id] }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="score" label="分数" width="151">
                                </el-table-column>
                                <el-table-column prop="low_section" label="位次" width="150">
                                </el-table-column>
                            </el-table>
                        </el-row>
                    </el-row>
                </el-row>
                <el-row class="tools-box-content" v-if="activeCardIndex == 1">
                    <div class="tools-score-search">
                        <div class="type-list">
                            <div class="title-box">科目类型：</div>
                            <div class="type-name">
                                <a v-for="(item,key) in local_type_list" :key="key" :class="activeTag == key?'active-tag':''" @click="activeTagHandler(key)">{{item}}</a>
                            </div>
                        </div>
                        <div class="type-list type-list-diff">
                            <div class="title-box">高考分数/预估分数：</div>
                            <div class="type-score">
                                分数范围：{{scoreList[0]?scoreList[0]:'--'}}分 到 {{scoreList[scoreList.length-1]?scoreList[scoreList.length-1]:'--'}}分
                            </div>
                        </div>
                        <div class="search-img header-search">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="score-form" @submit.native.prevent>
                                <el-form-item prop="score">
                                    <el-input placeholder="请输入高考分数/预估分数" v-model="ruleForm.score" @keyup.enter.native="searchRankListHandler()">
                                    </el-input>
                                    <div class="el-form-item__error" v-if="showErrorStatus">
                                        超出分数范围
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="searchRankListHandler" class="tools-btn">开始查询</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-row class="tools-rank-list" v-if="this.scoreList.length > 0 && !showNoData">
                    <!-- <el-row class="tools-rank-list" v-if="!showNoData"> -->
                        <div class="tools-rank-list-infor">
                            <el-row :gutter="16">
                                <el-col :span="12">
                                    <div class="tools-rank-item">
                                        <div class="tools-rank-item-title">
                                            位次区间
                                        </div>
                                        <div class="tools-rank-item-score">
                                            {{sectionInfor.high_section && sectionInfor.low_section?sectionInfor.high_section + '-'+ sectionInfor.low_section:''}}
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="tools-rank-item">
                                        <div class="tools-rank-item-title">
                                            建议位次
                                        </div>
                                        <div class="tools-rank-item-score">
                                            {{sectionInfor.low_section?((sectionInfor.low_section+sectionInfor.high_section)/2).toFixed(0):''}}
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div v-if="this.scoreList.length > 0">
                        <!-- <div> -->
                            <div class="tools-canvas-title">(人数)</div>
                            <!-- <div ref="toolsCanvas1" class="tools-canvas" v-if="showNoData"></div> -->
                            <div ref="toolsCanvas" class="tools-canvas" v-if="!showNoData"></div>
                        </div>
                    </el-row>
                </el-row>
                <el-row class="tools-box-content" v-if="activeCardIndex == 2 && provinceCode == '41'">
                    <div class="tools-score-search">
                        <div class="type-list">
                            <div class="title-box">科目类型：</div>
                            <div class="type-name">
                                <a v-for="(item,key) in local_type_list1" :key="key" :class="activeTag1 == key?'active-tag':''" @click="activeTagHandler1(key)">{{item}}</a>
                            </div>
                        </div>
                        <div class="type-list type-list-diff">
                            <div class="title-box">高考分数/预估分数：</div>
                            <div class="type-score">
                                分数范围：{{scoreList[0]?scoreList[0]:'--'}}分 到 {{scoreList[scoreList.length-1]?scoreList[scoreList.length-1]:'--'}}分
                            </div>
                        </div>
                        <div class="search-img header-search">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="score-form" @submit.native.prevent>
                                <el-form-item prop="score">
                                    <el-input placeholder="请输入高考分数/预估分数" v-model="ruleForm.score" @keyup.enter.native="searchRankListHandler()">
                                    </el-input>
                                    <div class="el-form-item__error" v-if="showErrorStatus">
                                        超出分数范围
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="searchRankListHandler" class="tools-btn">开始查询</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-row class="tools-rank-list" v-if="this.scoreList.length > 0 && !showNoData">
                    <!-- <el-row class="tools-rank-list" v-if="!showNoData"> -->
                        <div class="tools-rank-list-infor">
                            <el-row :gutter="16">
                                <el-col :span="12">
                                    <div class="tools-rank-item">
                                        <div class="tools-rank-item-title">
                                            位次区间
                                        </div>
                                        <div class="tools-rank-item-score">
                                            {{sectionInfor.high_section && sectionInfor.low_section?sectionInfor.high_section + '-'+ sectionInfor.low_section:''}}
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="tools-rank-item">
                                        <div class="tools-rank-item-title">
                                            建议位次
                                        </div>
                                        <div class="tools-rank-item-score">
                                            {{sectionInfor.low_section?((sectionInfor.low_section+sectionInfor.high_section)/2).toFixed(0):''}}
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div v-if="this.scoreList.length > 0">
                        <!-- <div> -->
                            <div class="tools-canvas-title">(人数)</div>
                            <div ref="toolsCanvas1" class="tools-canvas" v-if="!showNoData"></div>
                        </div>
                    </el-row>
                </el-row>
            </el-col>
            <el-col :span="8" class="tools-box-news">
                <SchoolRank></SchoolRank>
                <News></News>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getNewScoreSection, getScoreSection, getScoreLine } from '@/api/tools'
import echarts from 'echarts'
import { mapState } from 'vuex'
import { ContentLoader } from 'vue-content-loader'
export default {
    components: {
        ContentLoader
    },
    data() {
        const validateScore = (rule, value, callback) => {
            if (!value || value.length === 0) {
            callback(new Error("请输入分数"));
            } else {
                if ((/(^[1-9]\d*$)/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的分数"));
                }
            }
        }; 
        return {
            cardList: [],
            activeCardIndex: 0,
            activeTag: '',
            activeTag1: '',
            toolsList: [],
            ruleForm: {
                score: this.$store.state.user.gkInforObj.score
            },
            sectionInfor: {
                min_score: '--',
                low_section: '',
                high_section: '',
                max_score: '--'
            },
            rules: {
                score: [
                    { required: true, trigger: 'blur', validator: validateScore },
                ],
            },
            scoreList: [],
            peopleList: [],
            showErrorStatus: false,
            toolsStatus: '1',
            scoreLineList: [],
            province: '',
            showNoData: false,
            local_type_list: {},
            local_type_list1: {
                1: '物理',
                2: '历史'
            },
            local_batch_list: { 1: '本科一批', 2: '本科二批', 3: '专科批', 4: '本科批'},
            local_batch_new_list: { 1: '本科批', 3: '专科批', 4: '特控批'},
            has_code: 0
        };
    },
    computed: {
        ...mapState({
            provinceCode: state => state.user.provinceCode,
            token: state => state.user.token,
            function_code: state => state.user.function_code
        })
    },
    watch: {
        provinceCode (newVal) {
             if(newVal == '41') {
                this.cardList = ['批次线查询','位次查询','适考查询']
            } else {
                this.cardList = ['批次线查询','位次查询']
            }
            this.getAreaHandler()
            if(this.activeCardIndex == 0) {
                this.getScoreLineHandler();
            } else if(this.activeCardIndex == 1) {
                if(this.ruleForm.score) {
                    this.getScoreSectionHandler();
                }
            } else if(this.activeCardIndex == 2) {
                if(this.ruleForm.score) {
                    this.getNewScoreSectionHandler();
                }
            }
            if(newVal && this.ruleForm.score) {
                this.getScoreSectionHandler();
            }
        },
        token(newVal) {
            if(newVal != '') {
                this.getScoreLineHandler();
            }
        },
        function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00006'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }
    },
    mounted() {
        setTimeout(() => {
             if(this.provinceCode == '41') {
                this.cardList = ['批次线查询','位次查询','适考查询']
            } else {
                this.cardList = ['批次线查询','位次查询']
            }
            this.getAreaHandler()
            this.toolsStatus = 1;
            this.scoreLineList = [];
            this.getScoreLineHandler();
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00006'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }, 300)
    },
    methods: {
        getAreaHandler() {
            const areaInfo = JSON.parse(sessionStorage.getItem('proInfo'));
            const tmp = areaInfo.filter(val => { return val.area === this.provinceCode})[0] 
            this.province = tmp.name;
            const subject_tmp = JSON.parse(sessionStorage.getItem('newSubject'));
            subject_tmp.map(item => {
                this.local_type_list[item.local_type] = item.name
            })
            this.activeTag = Object.keys(this.local_type_list)[0];
            this.activeTag1 =  Object.keys(this.local_type_list)[0];
        },
        handleChangeCard(e) {
            this.activeCardIndex = e.index
            if(e.index == 0) {
                this.toolsStatus = 1;
                this.scoreLineList = [];
                this.getScoreLineHandler();
            } else if(e.index == 1) {
                if(this.ruleForm.score) {
                    this.getScoreSectionHandler();
                }
            } else if(e.index == 2) {
                if(this.ruleForm.score) {
                    this.getNewScoreSectionHandler();
                }
            }
        },
        activeTagHandler(key) {
            this.activeTag = key;
            this.searchRankListHandler()
        },
        activeTagHandler1(key) {
            this.activeTag1 = key;
            this.searchRankListHandler()
        },
        getScoreLineHandler() {
            let area = localStorage.getItem("area");
            getScoreLine(area).then((res) => {
                if(res.data.length == 0) {
                    this.toolsStatus = 2;
                    return
                }
                this.scoreLineList = res.data
                console.log(this.scoreLineList,'this.scoreLineList')
                this.toolsStatus = 3;
            }) 
        },
        sortObj(obj) {
            let arr = [];
            for (let i in obj) {
                arr.push([obj[i],i]);
            };
            arr.reverse();
            return arr;
        },
        searchRankListHandler() {
            if(this.activeCardIndex == 1) {
                this.$refs.ruleForm.validate((valid) => {
                    if(valid) { 
                        this.getScoreSectionHandler();
                    }
                })
            } else if(this.activeCardIndex == 2) {
                this.$refs.ruleForm.validate((valid) => {
                    if(valid) { 
                        this.getNewScoreSectionHandler();
                    }
                })
            }
        },
        myEcharts1() {
            const myChart = echarts.init(this.$refs.toolsCanvas);
            let that = this;
            let scoreIndex = that.scoreList.findIndex(element => element == that.ruleForm.score);
            const option = {
                tooltip: {
                    trigger: 'axis',
                    triggerOn: "none",
                    alwaysShowContent: true,
                    backgroundColor: 'rgba(0,0,0,0.40)',
                    borderRadius: 4,
                    showContent: true,
                    textStyle: {
                        fontSize: 14
                    },
                    axisPointer: {
                        lineStyle: {
                            color: "#dcdfe6"
                        }
                    },
                    formatter: function(params) {
                        const div = "<div style='padding: 8px 8px 2px 8px'>我的分数：" + params[0].name + "  &nbsp;&nbsp;同分" + that.peopleList[scoreIndex] + "人</div><div style='padding: 2px 8px 8px 8px'>" + "我的位次：" +that.sectionInfor.high_section + "-" + that.sectionInfor.low_section + "</div>";
                        return div;
                    },
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.scoreList,
                    axisLine: {
                        lineStyle: {
                            color: '#dcdfe6'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: "#5e6166",
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: 36,
                        interval(index) {
                            let length = that.scoreList.length;
                            if(index == 0 || index == length-1 || index == Math.floor(length*0.25) || index == Math.floor(length*0.5) || index == Math.floor(length*0.75)) {
                                return true
                            }
                        },
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    }, 
                    splitLine: {
                        lineStyle: {
                            color: '#dcdfe6',
                        }
                    },
                },
                series: [
                    {
                        data: this.peopleList,
                        type: 'line',
                        lineStyle: {
                            color: "#FE9F0A",
                            width: 2
                        },
                        itemStyle: {
                            borderWidth: 0.2
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                    [
                                        {offset: 0, color: 'rgba(254,159,10,0.21)'},
                                        {offset: 1, color: 'rgba(254,159,10,0.00)'}
                                    ]
                                )
                            },
                        }
                    },
                ]
            };
            myChart.setOption(option);
            myChart.dispatchAction({
                type:'showTip',
                seriesIndex: 0,
                dataIndex: scoreIndex,
            })
        },
        myEcharts2() {
            const myChart = echarts.init(this.$refs.toolsCanvas1);
            let that = this;
            let scoreIndex = that.scoreList.findIndex(element => element == that.ruleForm.score);
            const option = {
                tooltip: {
                    trigger: 'axis',
                    triggerOn: "none",
                    alwaysShowContent: true,
                    backgroundColor: 'rgba(0,0,0,0.40)',
                    borderRadius: 4,
                    showContent: true,
                    textStyle: {
                        fontSize: 14
                    },
                    axisPointer: {
                        lineStyle: {
                            color: "#dcdfe6"
                        }
                    },
                    formatter: function(params) {
                        const div = "<div style='padding: 8px 8px 2px 8px'>我的分数：" + params[0].name + "  &nbsp;&nbsp;同分" + that.peopleList[scoreIndex] + "人</div><div style='padding: 2px 8px 8px 8px'>" + "我的位次：" +that.sectionInfor.high_section + "-" + that.sectionInfor.low_section + "</div>";
                        return div;
                    },
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.scoreList,
                    axisLine: {
                        lineStyle: {
                            color: '#dcdfe6'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: "#5e6166",
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: 36,
                        interval(index) {
                            let length = that.scoreList.length;
                            if(index == 0 || index == length-1 || index == Math.floor(length*0.25) || index == Math.floor(length*0.5) || index == Math.floor(length*0.75)) {
                                return true
                            }
                        },
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    }, 
                    splitLine: {
                        lineStyle: {
                            color: '#dcdfe6',
                        }
                    },
                },
                series: [
                    {
                        data: this.peopleList,
                        type: 'line',
                        lineStyle: {
                            color: "#FE9F0A",
                            width: 2
                        },
                        itemStyle: {
                            borderWidth: 0.2
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                    [
                                        {offset: 0, color: 'rgba(254,159,10,0.21)'},
                                        {offset: 1, color: 'rgba(254,159,10,0.00)'}
                                    ]
                                )
                            },
                        }
                    },
                ]
            };
            myChart.setOption(option);
            myChart.dispatchAction({
                type:'showTip',
                seriesIndex: 0,
                dataIndex: scoreIndex,
            })
        },
        getScoreSectionHandler() {
            if(this.has_code == 0) {
                this.$message({
                    message: '您的账户暂未开通此功能',
                    type: 'warning'
                })
                return
            }
            let local_type_id = this.activeTag;
            let area = localStorage.getItem("area");
            getScoreSection(local_type_id,this.ruleForm.score, area).then(res => {
                if(res.data.score_data) {
                    this.sectionInfor = res.data.score_data;
                    this.scoreList = (res.data.all_data.map((item)=>{return item.min_score})).reverse();
                    this.peopleList = res.data.all_data.map((item)=>{return item.same_people}).reverse();
                    this.showErrorStatus = false
                    this.showNoData = false
                } else {
                    this.showErrorStatus = true
                    this.showNoData = true
                    return
                }
                if(this.$refs.toolsCanvas) {
                    const myChart = echarts.init(this.$refs.toolsCanvas);
                    myChart.clear();
                }
                this.$nextTick(() => {
                    this.myEcharts1();
                })      
            })
        },
        getNewScoreSectionHandler() {
            if(this.has_code == 0) {
                this.$message({
                    message: '您的账户暂未开通此功能',
                    type: 'warning'
                })
                return
            }
            let local_type_id = this.activeTag1;
            let area = localStorage.getItem("area");
            getNewScoreSection(local_type_id,this.ruleForm.score, area).then(res => {
                if(res.data.score_data) {
                    this.sectionInfor = res.data.score_data;
                    this.scoreList = (res.data.all_data.map((item)=>{return item.min_score})).reverse();
                    this.peopleList = res.data.all_data.map((item)=>{return item.same_people}).reverse();
                    this.showErrorStatus = false
                    this.showNoData = false
                } else {
                    this.showErrorStatus = true
                    this.showNoData = true
                    return
                }
                if(this.$refs.toolsCanvas1) {
                    const myChart = echarts.init(this.$refs.toolsCanvas1);
                    myChart.clear();
                }
                this.$nextTick(() => {
                    this.myEcharts2();
                })      
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.tools-rank-box {
    @include gwidth;
    .tools-box-content {
        padding: 0 24px 24px 24px;
        background: #ffffff;
        border-radius: 0 10px 10px 10px;
        box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10); 
        min-height: 350px;
        h5 {
            border-left: 2px solid $common-color;
            border-radius: 1px;
            font-size: 22px;
            font-weight: 600;
            color: #2c2e33;
            padding-left: 8px;
            text-align: left;
            padding-bottom: 0px;
            margin-bottom: 24px;
            margin-top: 0;
        }
    }
    .tools-score-search {
        background: url('../../assets/images/tools-search-bg.png') no-repeat;
        background-size: 100% 100%;
        height: 193px;
        padding: 24px;
        box-sizing: border-box;
        margin-top: 20px;
    }
    .type-list {
        @include gflex;
        font-size: 0;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 5px;
        .title-box {
            min-width: 78px;
            padding: 3px 6px 3px 0;
            font-size: 14px;
            text-align: left;
            color: #ffffff;
        }
        a {
            display: inline-block;
            font-size: 14px;
            color: #5e6166;
            color: #ffffff;
            text-align: center;
            margin-bottom: 12px;
            padding: 3px 6px;
            cursor: pointer;
        }
        a:not(:nth-child(13n)) {
            margin-right: 12px;
        }
        // a:hover {
        //     color: $common-color;
        // }
        .active-tag {
            color: $common-color!important;
            background: #ffffff;
            border-radius: 4px;
        }
        .type-name {
            @include gflex;
            width: calc(100% - 4px);
            justify-content: flex-start;
            flex-wrap: wrap;
        }
        .type-score {
            color: #ffd160;
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            padding: 3px 6px 3px 0;
        }
    }
    .search-img {
        margin-top: 10px;
    }
    .tools-btn {
        width: 136px;
        height: 52px;
        border: none!important;
        background: linear-gradient(90deg,#ffa94a, #ff913c);
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        border: none;
        margin-left: 14px;
        position: relative;
        top: 0px;
    }
    .type-list-diff {
        justify-content: left;
        line-height: 20px;
    }
    .tools-rank-list {
        .tools-rank-item {
            height: 80px;
            background: #ffffff;
            border: 1px solid #ebedf0;
            border-radius: 4px;
            text-align: center;
            line-height: 40px;
            .tools-rank-item-title {
                height: 40px;
                background: #f5f7fa;
            }
            .tools-rank-item-score {
                font-weight: 600;
                font-size: 18px;
                color: $common-color;
            }
        }
    }
}
.tools-batch-box {
    .tools-box-content {
        background: #ffffff;
        border-radius: 10px;
        min-height: 350px;
        padding-top: 24px;
    }
    .type-list {
        @include gflex;
        font-size: 0;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 8px;
        border-bottom: 1px solid #f0f2f5;
        padding-bottom: 12px;
        .title-box {
            width: 78px;
            padding: 3px 6px 3px 0;
            font-size: 14px;
            text-align: left;
            color: #909399;
        }
        a {
            display: inline-block;
            font-size: 14px;
            color: #5e6166;
            cursor: pointer;
            text-align: center;
            margin-bottom: 12px;
            padding: 3px 6px;
        }
        a:not(:nth-child(13n)) {
            margin-right: 12px;
        }
        a:hover {
            color: $common-color;
        }
        .active-tag {
            color: #ffffff!important;
            background: $common-color;
            border-radius: 4px;
        }
        .type-name {
            @include gflex;
            width: calc(100% - 4px);
            justify-content: flex-start;
            flex-wrap: wrap;
        }
    }
    .tools-batch-list {
        img {
            position: relative;
            top: 3px;
        }
        h5 {
            font-size: 22px;
            font-weight: 600;
            color: #2C2E33;
            text-align: left;
            margin: 0 0 24px 0;
            span {
                color: $common-color;
            }
        }
    }
}
.tools-canvas {
    position: relative;
    left: -90px;
    top: -45px;
    width:910px;
    height:450px;
}
.tools-canvas-title {
    font-size: 14px;
    color: #5e6166;
    margin-top: 32px;
}
.tools-box-news {
    margin-top: 24px;
}
.no-data-box {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
        margin-left: -14px;
    }
}
</style>